<template>
  <div v-loading="loading">
    <no-data v-if="orderId === null" />
    <!-- 订单列表右侧订单信息 -->
    <div v-else class="container paddingTop10 orderListInfo">
      <el-tabs v-model="tabs" class="marginLeft10">
        <el-tab-pane label="申请动态" name="0"></el-tab-pane>
        <el-tab-pane label="催单状态" name="1"></el-tab-pane>
        <el-tab-pane label="配送跟踪" name="2"></el-tab-pane>
        <el-tab-pane label="订单详情" name="3"></el-tab-pane>
        <el-tab-pane label="门店智控" name="4"></el-tab-pane>
      </el-tabs>
      <div style="height: 72vh; overflow: auto">
        <!--      申请动态-->
        <div v-if="tabs === '0'">
          <orderRefund ref="orderRefund" :order-id="orderId" @handleConfirm="handleConfirm" />
        </div>
        <!-- 催单动态 -->
        <div v-if="tabs === '1'">
          <orderRemind ref="orderRemind" :order-id="orderId" @handleConfirm="handleConfirm" />
        </div>
        <!-- 配送跟踪 -->
        <div v-if="tabs === '2'" class="ordListInfo paddingLeft10 paddingRight10">
          <orderDelivery ref="orderDelivery" :order-id="orderId" @handleConfirm="handleConfirm" />
        </div>
        <!-- 订单详情 -->
        <div v-if="tabs === '3'">
          <orderDetail ref="orderDetail" :order-id="orderId" />
        </div>
        <!-- 门店智控 -->
        <div v-if="tabs === '4'" class="hHP flex directionColumn marginLeft10 marginRight10">
          <orderStore ref="orderStore" :order-id="orderId" />
        </div>
      </div>
      <el-row class="grey paddingTop10" style="text-align: center; border-top: 1px solid rgb(235, 238, 245); position: fixed; bottom: 20px; width: 530px;">
        <!-- <div v-if="tabs === '2'" class="padding10 borderRadius5">
          <el-button v-if="orderInfo.bstatus === 0 || orderInfo.bstatus === 4 || orderInfo.bstatus === 7 || orderInfo.bstatus === 8 || orderInfo.bstatus === 9 || (orderInfo.bstatus === 5 && deliveryData.length > 0)" v-hasPermi="['order:orderProcessing:againDelivery']" type="warning" @click="handleDeliveryAgain(orderInfo.bstatus)">再次配送</el-button>
        </div> -->
        <div v-if="tabs === '3'" class="padding10 borderRadius5">
          <el-button v-if="orderInfo.bdelivery === 2" v-hasPermi="['order:orderProcessing:selfPickupFinish']" type="success" @click="handleOrderOver(orderInfo.corderNo)">自提完成</el-button>
          <el-button v-hasPermi="['order:orderProcessing:pickEdit']" type="warning" plain @click="orderDialogVisible = true">修改订单</el-button>
          <el-button v-if="(orderInfo.bdelivery === 1 || orderInfo.bdelivery === 4) && (orderInfo.bstatus === 1 || orderInfo.bstatus === 2 || orderInfo.bstatus === 6 || orderInfo.bstatus === 10)" v-hasPermi="['order:orderProcessing:humanDelivery']" type="primary" @click="deliveryOrderVisible = true">人工配送下单</el-button>
          <el-button v-if="orderInfo.bdelivery !== 2 && (orderInfo.bstatus === 1 || orderInfo.bstatus === 2 || orderInfo.bstatus === 3 || orderInfo.bstatus === 4 || orderInfo.bstatus === 5 || orderInfo.bstatus === 6 || orderInfo.bstatus === 10 || orderInfo.bstatus === 12 || orderInfo.bstatus === 0)" v-hasPermi="['order:orderProcessing:humanDelivery']" type="primary" @click="handleQunyunDelivery">一键发单</el-button>
        </div>
      </el-row>

      <el-dialog v-if="deliveryOrderVisible" class="elDialog" style="margin-top: -10vh;" :close-on-click-modal="false" :title="title" :visible.sync="deliveryOrderVisible" width="1000px" append-to-body>
        <deliveryOrderDialog v-if="deliveryOrderVisible" :order-info="orderInfo" :title="title" @handleConfirm="handleConfirm" @handleClose="handleClose" />
      </el-dialog>
      <el-dialog v-if="orderDialogVisible" :close-on-click-modal="false" title="修改订单" :visible.sync="orderDialogVisible" width="600px" append-to-body>
        <orderEdit v-if="orderDialogVisible" :order-info="orderInfo" @handleClose="handleClose" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import deliveryOrderDialog from "@/views/order/dialog/deliveryOrderDialog";
import NoData from "@/components/noData.vue";
import orderEdit from "@/views/order/orderEdit.vue";
import orderRefund from "@/views/order/component/orderRefund.vue";
import orderRemind from "@/views/order/component/orderRemind.vue";
import orderDelivery from "@/views/order/component/orderDelivery.vue";
import orderDetail from "@/views/order/component/orderDetail.vue";
import orderStore from "@/views/order/component/orderStore.vue";
export default {
  name: "OrderListInfo",
  components: {
    NoData,
    deliveryOrderDialog,
    orderEdit,
    orderRefund,
    orderRemind,
    orderDelivery,
    orderDetail,
    orderStore,
  },
  data() {
    return {
      loading: false,
      orderId: null,
      deliveryOrderVisible: false,
      rideLocationDialogVisible: false,
      orderDialogVisible: false,
      orderInfo: {},
      deliveryData: [],
      tabs: "5",
      title: "人工配送下单",
    };
  },
  methods: {
    handleConfirm() {
      this.deliveryOrderVisible = false;
      this.$emit("changeListData");
    },
    handleClose() {
      this.deliveryOrderVisible = false;
      this.rideLocationDialogVisible = false;
      this.orderDialogVisible = false;
    },
    changeListInfoData(orderId) {
      this.orderId = orderId;
      this.selectById(this.orderId);
      this.queryDelivery(this.orderId);
    },
    handleOrderOver(corderNo) {
      this.$confirm("确认操作？", "系统警告", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.topsAjax.post(`${this.baseUrls.ordDelivery}/selfTaked`, { orderNo: corderNo }).then(() => {
          this.$message.success("订单完成");
          this.$emit("changeListData");
        });
      });
    },
    handleQunyunDelivery() {
      this.$confirm("一键发单后无法再发其他配送，是否继续？", "系统警告", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        let url = `${this.baseUrls.deliveryQyOpen}/add`;
        this.topsAjax.post(url, { orderId: this.orderInfo.corderNo }).then(() => {
          this.loading = false;
          this.$message.success("发送成功");
        }).catch(() => {
          this.loading = false;
        });
      });
    },
    handleDeliveryAgain(bstatus) {
      if (bstatus == 8 || bstatus == 9) {
        this.$confirm("当前订单已有配送员接单，确认再次发起配送？", "系统警告", {
          confirmButtonText: "继续发单",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.deliveryOrderVisible = true;
        });
      } else {
        this.deliveryOrderVisible = true;
      }
    },
    /**
     * 根据id获取订单信息
     * @param id
     */
    selectById() {
      this.loading = true;
      let url = `${this.baseUrls.third}/get/` + this.orderId;
      this.topsAjax.get(url).then((response) => {
        this.loading = false;
        this.orderInfo = response;
        let tabOrderDetails = [1, 2, 6, 10, 11, 0];
        let tabDeliverys = [4, 7, 8, 9];
        if (this.tabs === "5") {
          if (tabOrderDetails.includes(this.orderInfo.bstatus)) {
            this.tabs = "3";
          } else if (this.orderInfo.bstatus === 3) {
            this.tabs = "1";
          } else if (tabDeliverys.includes(this.orderInfo.bstatus)) {
            this.tabs = "2";
          } else if (this.orderInfo.bstatus === 5) {
            this.tabs = "0";
          } else {
            this.tabs = "3";
          }
        } else {
          if (this.tabs === "0") {
            this.$refs.orderRefund.handleInit();
          } else if (this.tabs === "1") {
            this.$refs.orderRemind.handleInit();
          } else if (this.tabs === "2") {
            this.$refs.orderDelivery.handleInit();
          } else if (this.tabs === "3") {
            this.$refs.orderDetail.handleInit();
          } else if (this.tabs === "4") {
            this.$refs.orderStore.handleInit();
          }
        }
      });
    },
    queryDelivery() {
      this.deliveryData = [];
      let url = `${this.baseUrls.ordDelivery}/queryList`;
      let params = {
        rOrder: this.orderId,
      };
      this.topsAjax.get(url, params).then((response) => {
        this.deliveryData = response;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex: 1;
  flex-direction: column;

  &__body {
    flex: 1;
  }
}
</style>

<style lang="scss" scoped>
.labelGray {
  .el-descriptions-item__label:not(.is-bordered-label) {
    color: #909399;
  }

  .el-descriptions-item__container .el-descriptions-item__content,
  .el-descriptions-item__container .el-descriptions-item__label {
    display: inline-flex;
    justify-content: flex-end;
    margin-right: 10px;
  }
}
.is-selected {
  /* 选中效果的样式 */
  border-color: #409eff;
}
.ordListInfo {
  .el-card__body,
  .el-main {
    padding: 0;
  }

  .el-collapse-item__header {
    height: auto;
    line-height: 20px;
    background-color: rgb(247, 248, 250) !important;
  }

  .el-collapse-item__wrap {
    background-color: rgb(247, 248, 250) !important;
  }
}

.el-collapse-item__content {
  padding-bottom: 0;
}

.el-descriptions--medium:not(.is-bordered) .el-descriptions-item__cell {
  padding-top: 0;
}

.green {
  background-color: #60e722;
}

.center {
  display: flex;
  justify-content: center;
}

.circle {
  width: 25px; /* 圆的直径 */
  height: 25px; /* 圆的直径 */
  border-radius: 50%; /* 使元素成为圆形的关键属性 */
}

.layout {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  margin-bottom: 5px;
}
</style>
<style lang="scss" scoped>
.red {
  background-color: gray;
}

.circular {
  border-radius: 50%;
}
</style>
